import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { RecaptchaConfig } from '../types';

export const useRecaptcha = (config: RecaptchaConfig) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const executeRecaptchaAction = useCallback(async (): Promise<string> => {
    if (!executeRecaptcha) {
      throw new Error('reCAPTCHA not ready. Please try again.');
    }

    try {
      const token = await executeRecaptcha(config.action);
      return token;
    } catch (error) {
      throw new Error('reCAPTCHA verification failed. Please try again.');
    }
  }, [executeRecaptcha, config.action]);

  const isRecaptchaReady = useCallback((): boolean => {
    return !!executeRecaptcha;
  }, [executeRecaptcha]);

  return {
    executeRecaptchaAction,
    isRecaptchaReady
  };
};
